<template>
  <div class="productCodeApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:12px;"></div>
    <div class="cont">
      <div class="info">
        <h2 class="title"><div>{{setOrder.title}}</div>
          <span :class="setOrder.status == 2 ? 'curt' : ''">{{setOrder.status == 1 ? '待核销':'已核销'}}</span>
        </h2>
        <div class="code" :style="setOrder.status == 2  ? 'display:none' : ''">
          <p class="a1">核销订单二维码</p>
          <div class="expl">
            <div class="qrcode" id="qrcode" ref="qrCodeUrl"></div>
          </div>
          <p class="a2">扫码核销</p>
        </div>

        <h2 style="padding-bottom:10px">
          <p>周一至周日</p>
          <p>营业时间：{{setOrder.business}}</p>
          <p>以上信息仅供参考，具体以实际公示信息为准。</p>
        </h2>
        <h2 class="box">提交时间：{{setOrder.createtime}}</h2>
        <h2 class="box">使用数量：{{setOrder.num}}次</h2>
      </div>
      <div class="btn" @click="yesOrder" v-if="setOrder.state == 1 && setOrder.status == 1">确认核销</div>
    </div>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        positionFlag:false,
        setOrder:[],
        id:''
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      this.id = this.$route.query.id
    },
    mounted() {
      this.beforeMount();
      this.getOrder(this.$route.query.id);
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getCode:function(id){
        document.getElementById('qrcode').innerHTML = ''
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: 'http://user.4008005216.com/main/cancel?id='+id, // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
      yesOrder:function(){
        var that = this;
        var id = this.id;
        that.$confirm('是否立即核销订单？','提示').then(_ => {
          $.ajax({
            type:'post',
            url:that.$host+'home/gather/deliver',
            data:{
              id:id,
            },
            dataType:'json',
            success:function(data){
              if(data.status == 200){
                that.getOrder(id);
              }else{
                that.$alert(data.message,'提示')
              }
              that.fullscreenLoading = false;
            }
          })
        }).catch(_ => {});
      },
      getOrder:function(id){
        var that = this;
        var u = JSON.parse(localStorage.getItem('userjwt'));
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/cancel',
          data:{
            id:id,
            user_id:u.id
          },
          dataType:'json',
          success:function(data){
            that.setOrder = data.data;
            if(data.data.status == 1){
              that.getCode(id);
            }
            that.fullscreenLoading = false;
          }
        })
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%
  }
  .productCodeApp{
    background:#ececec;
    width:100%
  }
  .productCodeApp .cont{
    width:96%;
    display:block;
    margin:0 auto;
    z-index:99;
  }
  .productCodeApp .info{
    width:100%;
    display:block;
    position:relative;
    background:#fff;
    border-radius: 6px;
  }
  .productCodeApp .info .goDetail{
    position:absolute;
    right:3%;
    top:5%;
    font-size:14px;
    color:#666
  }
  .productCodeApp .info h2{
    font-size:15px;
    padding-top:10px;
    width:92%;
    display:block;
    margin:0 auto;
    font-weight:normal;
    color:#333;
  }
  .productCodeApp .info h2.box{
    border-top:solid 1px #f5f5f5;
    padding:15px 0
  }
  .productCodeApp .info h2 p{
    padding-bottom:5px;
    line-height:22px
  }
  .productCodeApp .info h2.title{
    color:#000;
    font-weight:bold;
    font-size:16px;
    padding:15px 0 12px 0
  }
  .productCodeApp .info h2.title div{
    margin-bottom:8px
  }
  .productCodeApp .info h2.title span{
    font-weight:normal;
    display:inlie-block;
    border:solid 1px #F56C6C;
    font-size:12px;
    padding:3px 5px;
    border-radius: 4px;
    color:#F56C6C;
    margin-right:8px;
  }
  .productCodeApp .info h2.title span.curt{
    color:#67C23A;
    border-color:#67C23A
  }
  .productCodeApp .info h2 a{
    color:#2F78FF;
    text-decoration: none;
  }
  .productCodeApp .info .code .expl{
    position:relative;
    width:170px;
    height:170px;
    margin:0 auto;
  }
  .productCodeApp .info .code img{
    display:block;
    margin:0 auto;
    width:170px;
    height:170px;
  }
  .productCodeApp .info .code .expl b{
    position:absolute;
    width:170px;
    height:170px;
    background:rgba(255,255,255,0.9);
    top:0;
    left:0;
    text-align:center;
    line-height:170px;
    font-weight:400;
    color:#f00
  }
  .productCodeApp .info .code p.a1{
    text-align:center;
    font-size:18px;
    padding:20px 0 10px 0;
    font-weight:bold
  }
  .productCodeApp .info .code p.a2{
    text-align:center;
    color:#666;
    font-size:14px;
    padding:10px 0
  }

  .productCodeApp .goods:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .productCodeApp .goods{
    background:#f5f5f5;
    width:92%;
    margin:0 auto 1px auto;
  }
  .productCodeApp .goods .left{
    float:left;
    width:16%;
    border-radius:5px;
    margin:4% 2% 2% 4%;
  }
  .productCodeApp .goods .right{
    float:left;
    margin-top:4%;
    width:73%;
    position: relative;
  }
  .productCodeApp .goods .right p{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#000;
    width:78%
  }
  .productCodeApp .goods .right .num{
    font-size: 13px;
    color: #999999;
    padding-top:12px;
  }
  .productCodeApp .goods .right .price{
    color:#f00;
    font-size:15px;
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    right:0;
    text-align:right
  }
  .productCodeApp .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }
  .productCodeApp .goods .right .price b{
    color: #f00;
    font-size:16px;
    font-weight:600;
  }

  .productCodeApp .goods .right .price i{
    color: #f00;
    font-size:13px;
    font-style:normal
  }
  
  .productCodeApp .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }

  .productCodeApp .btn{
    width:128px;
    margin:25px auto 0 auto;
    height:45px;
    background:#0059D6;
    text-align:center;
    line-height:45px;
    border-radius: 8px;
    color: #FFFFFF;
  }
</style>